import { headScript as raygun } from '../helpers/index.js';

export default function () {
    return raygun;
}
